<script setup lang="ts">
import { RouterLink } from 'vue-router'

import BrandLogo from '@/components/common/BrandLogo.vue'
import LanguageSwitcher from '@/components/header/LanguageSwitcher.vue'

/**
 * Focused shell for the authentication flows: no navigation to distract from
 * the form, but the language switcher stays reachable.
 */
</script>

<template>
  <div class="auth-scene flex min-h-dvh flex-col">
    <header class="flex items-center justify-between px-4 py-4">
      <RouterLink :to="{ name: 'home' }">
        <BrandLogo with-tagline />
      </RouterLink>
      <LanguageSwitcher />
    </header>

    <main class="flex flex-1 items-center justify-center px-4 py-8">
      <div class="w-full max-w-md">
        <slot />
      </div>
    </main>
  </div>
</template>
